


















import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { IBanner } from '~/assets/interfaces/banners'
import { isAbsoluteUrl } from '~/assets/functions/url'
import { filterUrl } from '~/assets/filters/url'
import MixinGeneral from '~/assets/mixins/general'
import ComponentImage from '~/components/images/image.vue'

@Component({
  components: {
    ComponentImage,
  },
})
export default class ComponentBannerStandard extends mixins(MixinGeneral) {
  @Prop({ type: Boolean, default: false }) readonly needPreload!: boolean
  @Prop({ type: Object, required: true }) readonly item!: IBanner

  get isAbsoluteUrl(): boolean {
    return isAbsoluteUrl.test(this.item.url)
  }

  get url(): string {
    return filterUrl(this.item.url)
  }

  get tagName(): string {
    return this.isAbsoluteUrl ? 'a' : 'nuxt-link'
  }

  get styleImageWrapper(): Record<string, string> {
    return this.item.aspectRatio
      ? { aspectRatio: String(this.item.aspectRatio) }
      : {}
  }
}
